__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@aca/cookies", "20.2.0", () => (() => (__webpack_require__(5675))), 1);
			register("@aca/core", "20.2.0", () => (() => (__webpack_require__(847))), 1);
			register("@aca/datetime", "20.2.0", () => (() => (__webpack_require__(4106))), 1);
			register("@aca/ui", "20.2.0", () => (() => (__webpack_require__(7013))), 1);
			register("@acadv/shared/services", "0.0.0", () => (() => (__webpack_require__(9033))), 1);
			register("@acadv/shared/telemetry", "0.0.0", () => (() => (__webpack_require__(1765))), 1);
			register("@acadv/shell/config", "0.0.0", () => (() => (__webpack_require__(6088))), 1);
			register("@angular/animations/browser", "20.3.25", () => (() => (__webpack_require__(1147))), 1);
			register("@angular/animations", "20.3.25", () => (() => (__webpack_require__(7172))), 1);
			register("@angular/common/http", "20.3.25", () => (() => (__webpack_require__(8015))), 1);
			register("@angular/common", "20.3.25", () => (() => (__webpack_require__(7610))), 1);
			register("@angular/core/primitives/di", "20.3.25", () => (() => (__webpack_require__(2867))), 1);
			register("@angular/core/primitives/signals", "20.3.25", () => (() => (__webpack_require__(5689))), 1);
			register("@angular/core/rxjs-interop", "20.3.25", () => (() => (__webpack_require__(9074))), 1);
			register("@angular/core", "20.3.25", () => (() => (__webpack_require__(5699))), 1);
			register("@angular/forms", "20.3.25", () => (() => (__webpack_require__(4456))), 1);
			register("@angular/material/badge", "20.2.9", () => (() => (__webpack_require__(1162))), 1);
			register("@angular/material/dialog", "20.2.9", () => (() => (__webpack_require__(4926))), 1);
			register("@angular/material/menu", "20.2.9", () => (() => (__webpack_require__(5157))), 1);
			register("@angular/material/slide-toggle", "20.2.9", () => (() => (__webpack_require__(3206))), 1);
			register("@angular/platform-browser/animations", "20.3.25", () => (() => (__webpack_require__(3835))), 1);
			register("@angular/platform-browser", "20.3.25", () => (() => (__webpack_require__(436))), 1);
			register("@angular/router", "20.3.25", () => (() => (__webpack_require__(6039))), 1);
			register("@fortawesome/angular-fontawesome", "3.0.0", () => (() => (__webpack_require__(1861))), 1);
			register("@fortawesome/pro-regular-svg-icons", "6.2.1", () => (() => (__webpack_require__(1134))), 1);
			register("@fortawesome/pro-solid-svg-icons", "6.2.1", () => (() => (__webpack_require__(559))), 1);
			register("@fullstory/browser", "2.0.8", () => (() => (__webpack_require__(3213))), 1);
			register("@microsoft/signalr", "8.0.0", () => (() => (__webpack_require__(4254))), 1);
			register("@ng-select/ng-select", "20.7.0", () => (() => (__webpack_require__(2223))), 1);
			register("@ngneat/until-destroy", "10.0.0", () => (() => (__webpack_require__(6127))), 1);
			register("@opentelemetry/api", "1.9.1", () => (() => (__webpack_require__(3236))), 1);
			register("@opentelemetry/exporter-metrics-otlp-http", "0.220.0", () => (() => (__webpack_require__(260))), 1);
			register("@opentelemetry/exporter-trace-otlp-http", "0.220.0", () => (() => (__webpack_require__(6880))), 1);
			register("@opentelemetry/resources", "2.9.0", () => (() => (__webpack_require__(3433))), 1);
			register("@opentelemetry/sdk-metrics", "2.9.0", () => (() => (__webpack_require__(9513))), 1);
			register("@opentelemetry/sdk-trace-base", "2.9.0", () => (() => (__webpack_require__(4279))), 1);
			register("@opentelemetry/sdk-trace-web", "2.9.0", () => (() => (__webpack_require__(3674))), 1);
			register("@opentelemetry/semantic-conventions", "1.43.0", () => (() => (__webpack_require__(7604))), 1);
			register("rxjs/operators", "7.5.7", () => (() => (__webpack_require__(3620))), 1);
			register("rxjs", "7.5.7", () => (() => (__webpack_require__(3393))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};